import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { getGameListByJumpList } from "@/lobby_common/api/basic_gen.js";
import { getGameOtherInfo } from "@/lobby_common/api/game_gen.js";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import { gameImg } from "@/lobby_common/utils/img.js";
import Collection from "@/components/collection/index.vue";
import GameMaintai from "@/components/game/game-maintai";
import { debounce, formattedValue } from "@/lobby_common/utils/index.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import gameItem from "@/components/game/game-item";
import zanwu from "@/assets/new/zanwu.png";
import Bus from "@/lobby_common/utils/bus.js";
import mode9More from "@/lobby_common/mixins_views/homeModule/mode9More.vue";
import { divideAccuracy, fadeInAnimate } from "@/lobby_common/utils/utils.js";
export default {
  name: "mode9",
  mixins: [hideGmae],
  components: {
    Collection,
    GameMaintai,
    gameItem,
    mode9More,
  },
  data() {
    return {
      formattedValue,
      gameImg,
      zhanwutype: false,
      zanwu: zanwu,
      navIndex: 0,
      pcList: [],
      isMore: false, // 是否显示加载更多
      page: 1,
      currGameId: null,
      brandGroupList: [],
      tagList: [],
      playList: [],
      gameForm: {
        brandGroupSid: undefined,
        gameTagSid: undefined,
        gamePlayTypeSid: undefined,
        gameGroupName: undefined,
      },
      curObj: {},
      intervalId: null,
      updateInterval: 5000,
    };
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    list() {
      // return this.pcList;
      return this.pcList.map((item, i) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
          eid: `101_14_${this.curindex}_${i}`,
        };
      });
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    baseConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config || {};
    },
    riskPreferenceSwitch() {
      return this.baseConfig.riskPreferenceSwitch === "STATUS_BOOL_TRUE";
    },
    modeList() {
      const itemList = this.item.list || [];
      const arr = itemList.filter((item) => item.isShow === 1);
      if (this.riskPreferenceSwitch && arr.length >= 2) {
        // 合规性  风险
        const a = { ...arr[0], modeType: "home" };
        const b = arr[1];
        arr[0] = b;
        arr[1] = a;
        this.navIndex = 1;
      } else {
        if (itemList[0]) itemList[0].modeType = "home";
      }
      // itemList.map((v) => {
      //   if (v.isShow === 1) arr.push(v);
      // });
      return arr;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
    showStyle() {
      return this.packetConfig.style || 1;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  watch: {},
  // async created() {
  //   // 皮肤1500系列逻辑，监听导航栏点击事件
  //   if (!this.IsMobile) {
  //     Bus.$on("mode9NavSelect", ({ data, i }) => {
  //       console.log("mode9NavSelect=>", data, i);
  //       this.handelSelect(data, i);
  //     });
  //   }
  // },
  // destroyed() {
  //   // 皮肤1500系列逻辑，移除监听导航栏点击事件
  //   Bus.$off("mode9NavSelect");
  // },
  mounted() {
    // console.log(this.arrContent, 'arrContent')
  },
  activated() {
    // console.log(this.navIndex, "this.navIndex");
    this.anchorScroll();
  },
  methods: {
    handelSelect(obj, i) {
      // console.log(obj, i, i === this.navIndex);
      // 多款游戏，重复点击，不重复请求
      if (i === this.navIndex && obj.jump?.type === "Jump_TYPE_MULTIPLE_GAME") {
        return;
      }
      this.$eventPost("click_navigation", {
        navName: obj.langInfoObj?.[this.lang]?.navName,
        navUid: obj.uid,
        jump_value: obj?.jump || {},
        eid: `101_18_${this.curindex}_${i}`,
      });
      this.$eventPost("click", {
        eid: `101_18_${this.curindex}_${i}`,
        time: Date.now(),
        navName: obj.langInfoObj?.[this.lang]?.navName,
        navUid: obj.uid,
        jump_value: obj?.jump || {},
      });
      this.curObj = { ...obj };
      if (obj.modeType === "home") {
        // 导航页首页
        this.navIndex = this.riskPreferenceSwitch ? 1 : 0;
        this.pcList = [];
        this.anchorScroll();
        return false;
      } else {
        // 多款游戏 & 其他
        this.navIndex = i;
        this.pcList = [];
        this.anchorScroll();
        if (obj.jump.type === "Jump_TYPE_MULTIPLE_GAME") {
          // 多款游戏
          this.getGamelistFun();
          // this.getTags();
        } else {
          // 其他
          goJoinEvent(obj.jump);
        }
      }
    },
    handelClick(item) {
      const obj = {
        jump_type: item.jumpType,
        jump_value: item.jumpValue,
        jump_Web_type: item.jumpWebType,
        jump_url: item.jumpUrl,
        web_menu_url: item.web_menu_url,
      };
      goJoinEvent(obj);
    },

    async getGamelistFun(page = 1) {
      this.page = page;
      this.zhanwutype = false;
      const obj = { ...this.gameForm };
      obj.brandGroupSid = obj.brandGroupSid || undefined;
      obj.gameTagSid = obj.gameTagSid || undefined;
      obj.gamePlayTypeSid = obj.gamePlayTypeSid || undefined;
      const { code, data } = await getGameListByJumpList({
        page: page || 1,
        page_size: 36,
        jumpSid: this.curObj.jump.multipleGame.sid,
        // bind_type: 2,
        ...obj,
      });
      if (code === 0) {
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          // if (!item.jpInfo.jpValue) {
          //   item.jpInfo = {
          //     jpValue: 7355645,
          //     updateTime: 1715753477788,
          //   };
          // }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = games;
        // this.pcList = [...new Set([...(data?.gameList || [])])];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
        this.zhanwutype = true;
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === 36;
      }
    },
    // 游戏一个一个出来
    getAnimationDelay(i) {
      const num = i % 36;
      return num * 0.02 + "s";
    },
    async getGamelistFunMore(page = 1) {
      this.page = page;
      const obj = { ...this.gameForm };
      obj.brandGroupSid = obj.brandGroupSid || undefined;
      obj.gameTagSid = obj.gameTagSid || undefined;
      obj.gamePlayTypeSid = obj.gamePlayTypeSid || undefined;
      const { code, data } = await getGameListByJumpList({
        page: page || 1,
        page_size: 36,
        jumpSid: this.curObj.jump.multipleGame.sid,
        // bind_type: 2,
        ...obj,
      });
      if (code === 0) {
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = [...new Set([...this.pcList, ...games])];
        // this.pcList = [...new Set([...this.pcList, ...(data.gameList || [])])];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === 36;
      }
    },
    moreFun() {
      this.getGamelistFunMore(this.page + 1);
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
    // 获取游戏标签、玩法
    async getTags() {
      const { code, data } = await getGameOtherInfo({
        // tag_type: 1,
        // bind_type: 2,
        // menu_id: Number(this.navId),
      });
      if (code === 0) {
        this.brandGroupList = data?.brandGroupList || []; // 厂商组
        this.tagList = data.tagList || []; // 标签
        this.playList = data.playList || []; // 玩法
      }
    },
    keyWordFun: debounce(function () {
      this.pcList = [];
      this.getGamelistFun();
    }, 200),
    returnDatalang(key) {
      const obj = {
        // 标签
        hot: this.$t("Datalang.HomePage_TYPE_hot"),
        new: this.$t("Datalang.HomePage_TYPE_new"),
        recommend: this.$t("Datalang.HomePage_TYPE_porpular"),
        // 玩法 1: "哈希链", 2: "哈希时间戳", 3: "哈希加密", 4: "币安哈希", 5: "常规", 6: "波场",
        1: this.$t("Datalang.HomePage_BTM_chain"),
        2: this.$t("Datalang.HomePage_BTM_timestamp"),
        3: this.$t("Datalang.HomePage_BTM_hash"),
        4: this.$t("Datalang.HomePage_BTM_binance"),
        5: this.$t("Datalang.HomePage_BTM_normal"),
        6: this.$t("Datalang.HomePage_BTM_tron"),
      };

      return obj[key];
    },
    pcLeaveGame() {
      this.currGameId = null;
      return;
    },
    judgeMode(opt) {
      console.log("judgeMode", opt);
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (opt.canTestPlay === "STATUS_BOOL_FALSE") {
        this.$store.commit("setRecordGame", opt);

        payGameFun(opt);
      } else {
        if (this.IsMobile) {
          // 游戏详情页面
          this.$isPopShow({
            show: true,
            views: "hgame",
            data: {
              ...opt,
            },
          });
        }
      }
    },
    // PC弹出真玩、试玩收藏
    pcPayGame(opt) {
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (this.IsMobile) return;
      this.currGameId = opt.gameGroupSid;
      return;
    },
    // PC真玩、试玩
    payGame(opt, canTestPlay, isRoom = false) {
      this.$store.commit("setRecordGame", opt);
      payGameFun(opt, canTestPlay, false, isRoom);
    },
    getGameIcon(keys) {
      const key = keys || null;
      if (key) return require(`@/assets/new/${key}.png`);
    },
    anchorScroll() {
      this.$nextTick(() => {
        console.log(this.navIndex, "this.navIndex");
        const menuItem = this.$refs.mode9NavItem[this.navIndex];
        if (menuItem) {
          // const scrollWrapper = menuItem.closest(".tab-center");
          const scrollWrapper = this.$refs.mode9NavWrap;
          if (scrollWrapper) {
            const itemRect = menuItem.getBoundingClientRect();
            const wrapperRect = scrollWrapper.getBoundingClientRect();
            // console.log(
            //   itemRect.left,
            //   itemRect.width,
            //   wrapperRect.left,
            //   wrapperRect.width
            // );
            // 计算需要滚动的位置，使当前项居中
            const scrollLeft =
              itemRect.left -
              wrapperRect.left -
              wrapperRect.width / 2 +
              itemRect.width / 2;
            // console.log(
            //   "scrollLeft",
            //   scrollLeft,
            //   scrollWrapper.scrollLeft,
            //   scrollWrapper.scrollLeft + scrollLeft
            // );

            scrollWrapper.scrollTo({
              left: scrollWrapper.scrollLeft + scrollLeft,
              behavior: "smooth",
            });
          }
        }
      });
    },
  },
};
